module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"session_timeout":"Завершение сессии через"},"en":{"session_timeout":"Session timeout"}}')
  delete Component.options._Ctor
}
